import { render, staticRenderFns } from "./MenuRodape.vue?vue&type=template&id=cab111aa&scoped=true&"
import script from "./MenuRodape.vue?vue&type=script&lang=js&"
export * from "./MenuRodape.vue?vue&type=script&lang=js&"
import style0 from "./MenuRodape.vue?vue&type=style&index=0&id=cab111aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab111aa",
  null
  
)

export default component.exports